import { render, staticRenderFns } from "./RegisterCup.vue?vue&type=template&id=5850efa2&"
import script from "./RegisterCup.vue?vue&type=script&lang=js&"
export * from "./RegisterCup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegisterCup.vue"
export default component.exports